import i18next from "i18next";
var headerLinks = {
  OG: [{
    text: "MENU",
    link: "/menu"
  }, {
    text: "ORDER NOW",
    link: "/order-online"
  }, {
    text: "JOIN WAITLIST",
    link: i18next.t("link.joinwaitlist.desktop", {
      defaultValue: "/home?waitlist=true"
    })
  }, {
    text: "CAREERS",
    link: "https://jobs.olivegarden.com/"
  }],
  LH: [{
    text: "ORDER NOW",
    link: "/order-online"
  }, {
    text: "MENU",
    link: "/menu"
  }, {
    text: "JOIN WAITLIST",
    link: i18next.t("link.joinwaitlist.desktop", {
      defaultValue: "/home?waitlist=true"
    })
  } // { text: "GIFT CARDS", link: "/gift-cards" },
  ],
  CS: [{
    text: "MENU",
    link: "/menu"
  }, {
    text: "ORDER ONLINE",
    link: "/order-online"
  }, {
    text: "LOCATIONS",
    link: "/locations/location-search"
  }]
};
export default headerLinks;